let decide: (() => Promise<boolean>) | null = null
export function registerSignInDecision(handler: () => Promise<boolean>): () => void {
  decide = handler
  return () => { if (decide === handler) decide = null }
}
/** OAuth requires a mounted, active privacy boundary; account comparison follows Google selection. */
export async function requestSignInDecision(): Promise<boolean> {
  if (!decide) throw new Error('The account privacy check is not ready. Please retry.')
  return decide()
}
